import * as api from 'syft-acp-core/api/resources/admin/deletedRTWDocuments'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('DELETED_RTW_DOCUMENTS_FETCH', api.fetchDeletedRTWDocuments)
}
